import { Button, Checkbox, Col, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormRadio, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import FormTimePicker from "components/form/FormProvide/FormTimePicker";
import Dragger from "antd/es/upload/Dragger";
import { CloseOutlined, CloudUploadOutlined } from "@ant-design/icons";

const SupLeaveRequestForm = ({
    leaveGroupOptions = [],
    onClose = () => { },
    isOpen = false,
    selectedDate = "",
    setpreviousFilew = () => { },
    onAttachFileChange = () => { },
    handleLeaveModalSubmit = () => { },
}) => {
    const { t } = useTranslation();
    const [form] = useForm(null);
    const [remainingLeaveDays, setRemainingLeaveDays] = useState(0);
    const [remainingLeaveHour, setRemainingLeaveHour] = useState(0);
    const [fileSizeInMB, setfileSizeInMB] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [fileType, setFileType] = useState([]);
    const [initialValuesFileName, setInitialValuesFileName] = useState([]);
    const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
    const [initialValuesFileType, setInitialValuesFileType] = useState([]);
    const [initialValuesFileList, setInitialValuesFileList] = useState([]);

    const onDeleteFile = (index) => {
        setImageUrl((prev) => prev.filter((_, i) => i !== index));
        setFileName((prev) => prev.filter((_, i) => i !== index));
        setfileSizeInMB((prev) => prev.filter((_, i) => i !== index));
        setFileType((prev) => prev.filter((_, i) => i !== index));
        setpreviousFilew(null);
    };

    const convertLeaveHour = (remainingLeaveHour) => {
        if (remainingLeaveHour === t("unlimited")) return t("unlimited");

        const leaveHour = parseFloat(remainingLeaveHour);

        if (!isNaN(leaveHour)) {
            if (leaveHour !== 0) {
                const hourPart = Math.floor(leaveHour);
                const decimalPart = leaveHour % 1;
                const minutes = Math.round(decimalPart * 60);
                const convertedMinutes = (minutes) / 100;

                return `${(hourPart + convertedMinutes).toFixed(2)}`;
            }
            return `0.00`;
        }

        return remainingLeaveHour;
    };

    const calculateMinStartDate = useCallback((values) => {
        if (selectedDate) {
            return dayjs(selectedDate);
        }
        return dayjs().startOf("year");
    }, [selectedDate]);

    const calculateMaxStartDate = useCallback((values) => {
        return dayjs().endOf("year")
    }, [])

    const calculateMinEndDate = useCallback((values) => {
        if (values?.startDate) {
            return dayjs(values.startDate);
        }
        return dayjs().startOf("year");
    }, []);

    const calculateMaxEndDate = useCallback((values) => {
        return dayjs().endOf("year")
    }, []);

    const validateDaysMin = useCallback(
        (values) => {
            if (values?.emergencyFlag != 'Y') {
                if (values?.requestCondition?.code == 'LEAVE_REQUEST_CONDITION_01') {
                    return dayjs().startOf("year").add(values?.advanceAtLeast, 'day')
                }
                if (values?.requestCondition?.code == 'LEAVE_REQUEST_CONDITION_02') {
                    return dayjs().startOf("year").subtract(values?.backDateWithin, 'day')
                } else {
                    return dayjs().startOf("year")
                }
            } else {
                return dayjs().startOf("year")
            }
        },
    );

    useEffect(() => {
        if (isOpen && selectedDate) {
            form.setFieldsValue({
                startDate: dayjs(selectedDate)
            });
        }
    }, [isOpen, selectedDate, form]);

    return (
        <FormAntd
            form={form}
            initialValues={{
                durationType: "ALLDAY"
            }}
            onFinish={(values) => {
                handleLeaveModalSubmit(values);
                form.resetFields();
                onClose();
            }}
        >
            <FormItem shouldUpdate={(prev, curv) =>
                prev.leaveTypeId !== curv.leaveTypeId ||
                prev.durationType !== curv.durationType ||
                prev.startDate !== curv.startDate
            }>
                {({ getFieldValue, setFieldValue, resetFields }) => {

                    const selectedOption = leaveGroupOptions?.find(
                        (option) => option?.leaveId === getFieldValue("leaveTypeId")
                    );

                    if (selectedOption?.unlimited === 'N') {
                        setRemainingLeaveDays(selectedOption?.remainingLeaveDays || 0)
                        setRemainingLeaveHour(convertLeaveHour(selectedOption?.remainingLeaveHour || 0))
                    } else {
                        setRemainingLeaveDays(t("unlimited"));
                        setRemainingLeaveHour(t("unlimited"));
                    }

                    const leaveGroupActiveOptions = leaveGroupOptions?.filter?.((col) => col.statusFlag === 'ACTIVE');

                    console.log("selectedOptionselectedOption", selectedOption);

                    return (
                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                            <FormSelect
                                name="leaveTypeId"
                                label={t('leave_type.label.leave_type')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                required
                                options={leaveGroupActiveOptions}
                                onChange={(val, option) => {
                                    if (option?.unlimited === 'N') {
                                        setRemainingLeaveDays(option?.remainingLeaveDays || 0);
                                        setRemainingLeaveHour(convertLeaveHour(option?.remainingLeaveHour || 0));
                                    } else {
                                        setRemainingLeaveDays(t("unlimited"));
                                        setRemainingLeaveHour(t("unlimited"));
                                    }
                                }}
                            />

                            {(selectedOption?.emergencyLeave === "Y" && selectedOption?.annualLeaveLimit - selectedOption?.emergencyUsed >= 0) &&
                                <Col span={24}>
                                    <Row>
                                        <Col span={5}>
                                            <label> {t('leave_type.label.use-emergency-leave')}   </label>
                                        </Col>
                                        <Col span={1}>
                                            <Checkbox name="emergencyFlag"
                                                onChange={(e) => {
                                                    setFieldValue("emergencyFlag", e.target.checked ? 'Y' : 'N');
                                                }}
                                            >
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Col>
                            }

                            <Row>
                                <Col span={12} style={{ paddingRight: "8px" }}>
                                    <FormInput
                                        name="totalLeaveDays"
                                        label={t('leave_type.label.remaining-leave-day')}
                                        placeholder={remainingLeaveDays}
                                        size="large"
                                        readOnly
                                        textAlign={"right"}
                                    />
                                </Col>
                                <Col span={12} style={{ paddingLeft: "8px" }}>
                                    <FormInput
                                        name="totalLeaveHourShow"
                                        label={t('leave_type.label.remaining-leave-hour')}
                                        placeholder={remainingLeaveHour}
                                        size="large"
                                        readOnly
                                        textAlign={"right"}
                                    />
                                </Col>
                            </Row>
                            <Col span={24}>
                                <FormRadio
                                    name="durationType"
                                    label={t('leave_type.label.duration')}
                                    options={[
                                        {
                                            label: t('leave_type.label.all-day'),
                                            value: "ALLDAY",
                                        },
                                        {
                                            label: t('leave_type.label.hour'),
                                            value: "HOUR",
                                        },
                                    ]}
                                    required
                                />
                            </Col>

                            {getFieldValue("durationType") === "ALLDAY"
                                ? (<>
                                    <FormDatePicker
                                        name="startDate"
                                        label={t('leave_type.label.start_leave_date')}
                                        placeholder={t('common.placeholder.ddmmyyyy')}
                                        size="large"
                                        required
                                        minDate={calculateMinStartDate(getFieldValue())}
                                    // maxDate={calculateMaxStartDate(getFieldValue())}
                                    />
                                    <FormDatePicker
                                        name="endDate"
                                        label={t('leave_type.label.end-leave-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy')}
                                        size="large"
                                        required
                                        minDate={calculateMinEndDate(getFieldValue())}
                                    // maxDate={calculateMaxEndDate(getFieldValue())}
                                    />
                                </>)
                                : (<>
                                    <FormDatePicker
                                        name="startDate"
                                        label={t('my_request.label.leave-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy')}
                                        size="large"
                                        required
                                        minDate={validateDaysMin(getFieldValue())}
                                    />
                                    <Row >
                                        <Col span={12} style={{ paddingRight: "8px" }}>
                                            <FormTimePicker
                                                name="startTime"
                                                label={t('leave_type.label.start-time')}
                                                format="HH:mm:ss"
                                                size="large"
                                                required
                                            />
                                        </Col>
                                        <Col span={12} style={{ paddingLeft: "8px" }}>
                                            <FormTimePicker
                                                name="endTime"
                                                label={t('leave_type.label.end-time')}
                                                format="HH:mm:ss"
                                                size="large"
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </>)
                            }

                            <FormInput
                                type="textarea"
                                name="description"
                                label={t("expense.lable.reason")}
                                placeholder={t("please-enter")}
                                required
                                rows={1}
                                size="large"
                            />

                            {selectedOption?.attachment === "Y" &&
                                <>
                                    <Dragger
                                        name="attachFile"
                                        multiple={false}
                                        showUploadList={false}
                                        onRemove={() => onDeleteFile()}
                                        onChange={(e) => {
                                            if (e.event) {
                                                onAttachFileChange({
                                                    attachFile: e,
                                                    setFieldValue,
                                                    setImageUrl,
                                                    setFileName,
                                                    initialValuesImageUrl,
                                                    initialValuesFileName,
                                                    initialValuesFileType,
                                                    initialValuesFileList,
                                                    setInitialValuesFileName,
                                                    setInitialValuesFileType,
                                                    setInitialValuesImageUrl,
                                                    setInitialValuesFileList
                                                });
                                            }
                                        }}
                                        style={{
                                            border: "1px solid #EAECF0",
                                            borderRadius: "10px",
                                            background: "#FAFAFA",
                                            padding: "20px",
                                        }}
                                    >
                                        <p>
                                            <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                                        </p>
                                        <p
                                            style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                                        >
                                            {t("description.Select the desired file or drag and drop")}
                                        </p>
                                    </Dragger>
                                    <p>{t('description.Supported files mb')}</p>
                                </>
                            }
                            {imageUrl && (
                                <>
                                    {imageUrl?.map((attachFile, index) => (
                                        <>
                                            {index === 0 && (
                                                <Col span={24}>
                                                    <label >
                                                        {t('employee.label.attachment-file')}
                                                    </label>
                                                </Col>
                                            )}

                                            <Row>
                                                <div
                                                    style={{
                                                        border: "2px solid var(--button-color)",
                                                        borderRadius: "10px",
                                                        padding: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        maxWidth: "500px",
                                                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    <a
                                                        href={attachFile}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            textDecoration: "none",
                                                        }}
                                                    >
                                                        <img
                                                            src={attachFile}
                                                            alt="uploaded"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.display = "none";
                                                                const fallbackElement = e.target.nextElementSibling;
                                                                if (fallbackElement) fallbackElement.style.display = "block";
                                                            }}
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                objectFit: "cover",
                                                                borderRadius: "5px",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                                            <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                                        </div>
                                                    </a>
                                                    <Button
                                                        type="default"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            color: "#888",
                                                            cursor: "pointer",
                                                            fontSize: "18px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                        onClick={() => {
                                                            const newImage = imageUrl.filter((_, i) => i !== index);
                                                            const newFileName = fileName.filter((_, i) => i !== index);
                                                            const newFileSize = fileSizeInMB.filter((_, i) => i !== index);
                                                            const newFileType = fileType.filter((_, i) => i !== index);

                                                            setImageUrl(newImage);
                                                            setFileName(newFileName);
                                                            setfileSizeInMB(newFileSize);
                                                            setFileType(newFileType);

                                                            form.setFieldsValue({
                                                                attachFile: newImage,
                                                                attachFileName: newFileName,
                                                                attachFileType: newFileType,
                                                            });
                                                        }}
                                                    >
                                                        <CloseOutlined />
                                                    </Button>
                                                </div >
                                            </Row >
                                        </>
                                    ))}
                                </>
                            )
                            }

                            <Row style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => {
                                        resetFields();
                                        onClose();
                                    }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.save").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>

    )
}

export default SupLeaveRequestForm;